import { render, staticRenderFns } from "./search-price-slider.vue?vue&type=template&id=5803df62"
import script from "./search-price-slider.vue?vue&type=script&lang=js"
export * from "./search-price-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports